import '@/metrika'
// import '@/logger'
import '@/loader'
import '@/toastify'
import '@/scroll-to'
//import '@/main'

import * as Turbo from "@hotwired/turbo"

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

const Stimulus = Application.start()
// Stimulus.debug = process.env.NODE_ENV === "development"
// Stimulus.debug = process.env.NODE_ENV === "development"

const context = require.context("./controllers", true, /\.js$/)
Stimulus.load(definitionsFromContext(context))

Turbo.start()

const defaultErrorHandler = Stimulus.handleError.bind(Stimulus);

// configure Sentry to log errors and prepend the default handler
// const sentryErrorHandler = (error, message, detail = {}) => {
//   defaultErrorHandler(error, message, detail);
// //   Sentry.captureException(error, { message, ...detail });
// };

// overwrite the default handler with our new composed handler
// Stimulus.handleError = sentryErrorHandler;

// addEventListener('turbo:before-render', (event) => {
//     console.log(event.detail);
//     // event.preventDefault()
  
//     // await animateOut()
  
//     // event.detail.resume()
// })